import React from 'react';
import PropTypes from 'prop-types';
import { CcJsDataContextProvider } from '@bingads-webui-cc-react/js-data-rest';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { initCcJsData } from '../global-init/init-cc-js-data';

export const withCcJsDataContextProvider = (WrappedComponent) => {
  const HOC = (props) => {
    const { serverContext } = props;
    const { jsDataCcRest } = initCcJsData({ serverContext });

    return (
      <CcJsDataContextProvider initialJsData={jsDataCcRest}>
        <WrappedComponent {...props} />
      </CcJsDataContextProvider>
    );
  };

  HOC.propTypes = {
    serverContext: PropTypes.shape({
      CurrentUser: PropTypes.shape({ Id: PropTypes.number }).isRequired,
      CurrentCustomer: PropTypes.shape({ Id: PropTypes.number }).isRequired,
      ServicesEndpoints: PropTypes.shape({
        ClientCenterUIAPI: PropTypes.string.isRequired,
      }),
    }).isRequired,
  };

  return withServerContext(HOC);
};
